export default __webpack_public_path__ + "static/media/buffet.3241d83a.JPG";